/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_ad__magazine__first_line = /** @type {(inputs: {}) => string} */ () => {
	return `Unsere Top-Reiseziele und alle unsere Reiseinspirationen sind in`
};

const en_ad__magazine__first_line = /** @type {(inputs: {}) => string} */ () => {
	return `Our must-see destinations and all our travel inspirations are in`
};

const es_ad__magazine__first_line = /** @type {(inputs: {}) => string} */ () => {
	return `Nuestros destinos imprescindibles y todas nuestras inspiraciones viajeras están en`
};

const fr_ad__magazine__first_line = /** @type {(inputs: {}) => string} */ () => {
	return `Nos destinations incontournables et toutes nos inspirations de voyage sont dans`
};

const it_ad__magazine__first_line = /** @type {(inputs: {}) => string} */ () => {
	return `Le nostre mete imperdibili e tutte le nostre ispirazioni di viaggio sono in`
};

const nl_ad__magazine__first_line = /** @type {(inputs: {}) => string} */ () => {
	return `Onze must-see bestemmingen en al onze reisinspiraties staan in`
};

const pt_ad__magazine__first_line = /** @type {(inputs: {}) => string} */ () => {
	return `Os nossos destinos imperdíveis e todas as nossas inspirações de viagem estão em`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__first_line = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ad__magazine__first_line(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ad__magazine__first_line", locale)
	if (locale === "de") return de_ad__magazine__first_line(inputs)
	if (locale === "en") return en_ad__magazine__first_line(inputs)
	if (locale === "es") return es_ad__magazine__first_line(inputs)
	if (locale === "fr") return fr_ad__magazine__first_line(inputs)
	if (locale === "it") return it_ad__magazine__first_line(inputs)
	if (locale === "nl") return nl_ad__magazine__first_line(inputs)
	return pt_ad__magazine__first_line(inputs)
};